/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_AriaInputs */



/**
* | output |
* | --- |
* | "Edit priority" |
*
* @param {Explorer_Info_Priority_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_aria = /** @type {((inputs?: Explorer_Info_Priority_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "de") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "it") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "es") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Edit priority")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Edit priority")
	return /** @type {LocalizedString} */ ("Edit priority")
});